//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
export default {
  name: 'outTimeOrder',
  components: {
      cmBlank,cmLoadmore
  },
  inject:['reload'],
  data () {
    return {
        title:'超时订单',
      grade:0,
      isActive:3,
      pop:false,
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      phone:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      type:0,
      itemId:0,
      list:[],
      days:[
          {
              key:3,
              text:'三天以上'
          },
          {
              key:4,
              text:'四天以上'
          },
          {
              key:5,
              text:'五天以上'
          },
          {
              key:10,
              text:'十天以上'
          },
      ],
    }
  },
  created(){
    this.type = Number(this.$route.params.type);
    this.grade = parseInt(this.$func.getLocal('grade'));
    // if(this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8){
    //     this.getWorker();
    // }
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    selectDays(key){
        this.loadStatus = false;
        this.isActive = key;
        this.lastId = 0;
        this.list = [];
        this.getList();
    },
    getList(){
        this.$api.suboutTimeOrder({last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone,day:this.isActive}).then((res)=>{
          if(res){
            // console.log(res);
            if(!this.lastId){
                this.blankShow = res.data.length > 0 ? false : true;
            }
            this.hasNext = res.hasNext;
            this.lastId = res.lastId;
            res.data.forEach((item)=>{
                this.list.push(item);
            });
          }
        })  
    },
    loadmore(){
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        // console.log(1111);
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/suboutTimeOrder.vue